const ROOT = "containers/CronOrdersList/"

export const REQUEST_ORDER = `${ROOT}REQUEST_ORDER`
export const RECEIVE_ORDER = `${ROOT}RECEIVE_ORDER`

export const CLEAR_ORDER = `${ROOT}CLEAR_ORDER`
